import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const eventCategorySelector = createFeatureSelector<IState>('eventCategory');
export const getEventCategoriesSelector = createSelector(eventCategorySelector, (state: IState) => state); 
export const getEventCategorySelector = createSelector(eventCategorySelector, (state: IState) => state.selectedItem); 

